import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useInvestorPortalAuth } from "@/contexts/InvestorPortalAuthContext";

export default function RequireInvestorSession() {
  const { phase } = useInvestorPortalAuth();
  const location = useLocation();
  if (phase === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-porcelain text-warmGrey" data-testid="investor-portal-checking">
        <p className="text-sm">Lade …</p>
      </div>
    );
  }
  if (phase !== "authenticated") {
    return (
      <Navigate to="/portal/investor/login"
        state={{ from: location.pathname + location.search }} replace />
    );
  }
  return <Outlet />;
}
